import React from 'react';
import loader from '../loader';

export default loader(() => import('./index.jsx'));
